import React from 'react';
import { Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-foodCream pt-16 pb-8" data-id="element-41" data-mp="3geze367ujv27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42" data-mp="3ggtxuh7dth4p">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-43" data-mp="32oni2w855c5s">
          <div className="md:col-span-2" data-id="element-44" data-mp="36pfu1x8edv5r">
            <a href="#" className="font-display text-3xl font-extrabold text-foodMaroon uppercase tracking-tighter block mb-4" data-id="element-45" data-mp="36qhdoq3hbpz3">
              The Food Pavilion
            </a>
            <p className="text-foodMaroon/80 font-medium max-w-sm mb-6" data-id="element-46" data-mp="387fbm8yvbf9">
              A community food hub dedicated to creating pathways to prosperity
              for local culinary talent while bringing neighbors together.
            </p>
            <div className="flex gap-4" data-id="element-47" data-mp="29zgkq0kfasm4">
              <a href="https://www.instagram.com/thefoodpavilionsf/" target="_blank" rel="noopener noreferrer" aria-label="Follow The Food Pavilion on Instagram" className="w-12 h-12 bg-foodMaroon text-foodCream flex items-center justify-center hover:bg-foodOrange transition-colors border-2 border-foodMaroon shadow-[2px_2px_0px_0px_#34302A]" data-id="element-48" data-mp="29ydwy1ied6af">
                <Instagram size={24} data-id="element-49" data-mp="3v5dgqrrxl8sy" />
              </a>
              <a href="#" className="w-12 h-12 bg-foodMaroon text-foodCream flex items-center justify-center hover:bg-foodOrange transition-colors border-2 border-foodMaroon shadow-[2px_2px_0px_0px_#34302A]" data-id="element-50" data-mp="3q7u1ppnesrzy">
                <Mail size={24} data-id="element-51" data-mp="hsk3wtqjy8xz" />
              </a>
            </div>
          </div>

          <div data-id="element-52" data-mp="huo4b1p8spti">
            <h4 className="font-extrabold uppercase text-xl mb-4" data-id="element-53" data-mp="cu0hks81qv53">Explore</h4>
            <ul className="space-y-2 font-bold" data-id="element-54" data-mp="cw34329zq652">
              <li data-id="element-55" data-mp="qujk5jtqt8zv">
                <a href="#popups" className="hover:text-foodOrange transition-colors" data-id="element-56" data-mp="qu1ejwl6xifa">
                  Monthly Pop-Ups
                </a>
              </li>
              <li data-id="element-57" data-mp="twxrd9sgza9b">
                <a href="#workshops" className="hover:text-foodOrange transition-colors" data-id="element-58" data-mp="tta24mu25a0e">
                  Workshops
                </a>
              </li>
              <li data-id="element-59" data-mp="18k0txuvng93i">
                <a href="#vendors" className="hover:text-foodOrange transition-colors" data-id="element-60" data-mp="18k94vh87p4c2">
                  Become a Vendor
                </a>
              </li>
              <li data-id="element-61" data-mp="1hjnvqhsajgx3">
                <a href="#partners" className="hover:text-foodOrange transition-colors" data-id="element-62" data-mp="1hj4c8wmzskgy">
                  Partner With Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-63" data-mp="3obeu9jv44w7n">
            <h4 className="font-extrabold uppercase text-xl mb-4" data-id="element-64" data-mp="3obx0987kuosr">Visit Us</h4>
            <address className="not-italic font-medium text-foodMaroon/80 space-y-2" data-id="element-65" data-mp="3t9yijqx6ik36">
              <p data-id="element-66" data-mp="3tc2tgsthwjcy">India Basin Waterfront Park</p>
              <p data-id="element-67" data-mp="2ag5d6l9xj2e0">900 Innes Ave</p>
              <p data-id="element-68" data-mp="2ah84uvf2t8uz">San Francisco, CA 94124</p>
              <p className="pt-2 font-bold text-foodMaroon" data-id="element-69" data-mp="25nvheom4v83t">Operating Hours:</p>
              <p data-id="element-70" data-mp="21mtjcb3yd23f">Saturday & Sunday • 12 PM – 6 PM</p>
              <p className="pt-2 font-bold text-foodMaroon" data-id="element-71" data-mp="21nbknm5h26i7">
                Open Office Hours:
              </p>
              <p data-id="element-72" data-mp="1wpjtiucniof2">1st & 3rd Mondays • 5 PM – 7 PM</p>
            </address>
          </div>
        </div>

        <div className="border-t-4 border-foodMaroon pt-10 pb-10 flex flex-col items-center gap-6" data-id="element-73" data-mp="2tbvjgkowakxp">
          <h4 className="font-extrabold uppercase text-sm tracking-widest text-foodMaroon/60" data-id="element-74" data-mp="2pa9y0ayaoybw">
            In Partnership With
          </h4>
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12" data-id="element-75" data-mp="2feq6s1uoenth">
            <img src="https://cdn.magicpatterns.com/uploads/2ZSi3AccgZnEUBmfgiuxMw/Untitled_design_(4).png" alt="San Francisco Recreation & Parks" className="h-24 w-auto object-contain" data-id="element-76" data-mp="18xuy354j9jtw" />
            <img src="https://cdn.magicpatterns.com/uploads/nYkbhZjohnn3Xbm3r4WWAs/Untitled_design_(5).png" alt="India Basin Waterfront Park, San Francisco" className="h-24 w-auto object-contain" data-id="element-77" data-mp="2ruxzgaolfsvm" />
          </div>
        </div>

        <div className="border-t-4 border-foodMaroon pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-78" data-mp="2ntcmkpc27elf">
          <p className="font-bold text-sm" data-id="element-79" data-mp="3bk8dlk8oy5rm">
            © {new Date().getFullYear()} The Food Pavilion. All rights
            reserved.
          </p>
          <div className="flex gap-4 text-sm font-bold" data-id="element-80" data-mp="31lsvg6rn66u9">
            <a href="#" className="hover:text-foodOrange" data-id="element-81" data-mp="31las6q6kascu">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-foodOrange" data-id="element-82" data-mp="36isu3wm5w7bc">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}